import { faArrowTurnDownLeft } from '@fortawesome/pro-regular-svg-icons';

import { optionMessage, splitOption } from './messageContent.ts';
import { withIcon } from '../../core/components/Icon.tsx';
import classnames from '../../core/utils/classnames.tsx';

const EnterIcon = withIcon(faArrowTurnDownLeft);

export const OptionCards = ({
    options,
    chosen = null,
    onChoose = null,
}: {
    options: string[];
    chosen?: string | null;
    onChoose?: ((message: string) => void) | null;
}) => (
    <div className="mt-3 flex flex-col gap-2">
        {options.map((option) => {
            const { label, detail } = splitOption(option);
            const isChosen = chosen === optionMessage(option);
            return (
                <button
                    key={option}
                    type="button"
                    disabled={!onChoose}
                    onClick={() => onChoose?.(optionMessage(option))}
                    className={classnames(
                        'flex w-full items-center gap-3 rounded-lg border border-solid bg-surface-weak-default px-3 py-2 text-left outline-none transition-colors focus-visible:ring-2 focus-visible:ring-line-brand-strong',
                        isChosen ? 'border-line-brand-default' : 'border-line-weak',
                        onChoose
                            ? 'cursor-pointer hover:bg-surface-weak-hover active:bg-surface-weak-active'
                            : 'cursor-default',
                        !onChoose && !isChosen && 'opacity-50'
                    )}
                >
                    <span className="flex min-w-0 flex-1 flex-col">
                        <span className="text-sm font-medium text-content-strong">{label}</span>
                        {detail && <span className="text-xs text-content-medium">{detail}</span>}
                    </span>
                    <EnterIcon className="flex-none text-content-weak" />
                </button>
            );
        })}
    </div>
);
